module.exports = __webpack_public_path__ + "static/media/ic_head4.613e4495.png";